import { AppShell } from '@/components/shell/AppShell';
import { AuthGuard } from '@/lib/auth/AuthGuard';
import { studentCommands, studentNav } from '@/lib/nav/student';

export function StudentLayout() {
  return (
    <AuthGuard audience="student">
      <AppShell audience="student" nav={studentNav} commands={studentCommands} />
    </AuthGuard>
  );
}
